import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    ContainerSensorCheckType,
    ContainerOutcomeCode,
} from 'app/enums/label.enums'
import {
    ContainerAutomatedSensorCheck,
} from '../../containers.types'

const getColumns = (
    l: (v: string) => string,
): RichTableColumns<keyof ContainerAutomatedSensorCheck>[] => {
    return [
        {
            id: 'checkType',
            headerProps: {
                children: l('NAME'),
                sorting: false,
            },
            mapCellProps: 'checkType',
            allowedValuesEnum: ContainerSensorCheckType,
            componentName: 'EnumValue',
            width: '90px',
        },
        {
            id: 'outcomeCode',
            headerProps: {
                children: l('OUTCOME'),
                sorting: false,
            },
            mapCellProps: 'outcomeCode',
            allowedValuesEnum: ContainerOutcomeCode,
            componentName: 'EnumValue',
            width: '250px',
        },
        {
            id: 'outcomeDetailsMessage',
            headerProps: {
                children: l('OUTCOME_DETAILS'),
                sorting: false,
            },
            mapCellProps: 'outcomeDetailsMessage',
        },
        {
            id: 'createdOn',
            headerProps: {
                children: l('CREATED_ON'),
                sorting: false,
            },
            mapCellProps: 'createdOn',
            width: '150px',
        },
    ]
}

export default getColumns
